<template>
  <a-layout>
    <a-layout-content class="full-center-layout">
      <slot></slot>
    </a-layout-content>
  </a-layout>
</template>

<style lang="scss">
$body-content-height: 100vh;

.full-center-layout {
  min-height: #{$body-content-height};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  &.ant-layout-content {
    flex: unset;
  }

  @media screen and (max-width: $screen-lg) {
    min-height: auto;
  }

  // Mobile
  @media screen and (max-width: $screen-sm) {
    min-height: auto;
    background: $non-auth-background !important;
  }
}
</style>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { isPrivateSite } from "@/shared/utils/config";
import { windowSizeSimpleStore } from "@/shared/store/simpleStore/windowSizeData";

export default defineComponent({
  setup() {
    const isMobileScreen = computed(() => windowSizeSimpleStore.isMobile);

    return {
      isPrivateSite,
      isMobileScreen,
    };
  },
});
</script>
